import React from "react";
import { useTracking } from "../hooks/useActivityHistory";
import { ServiceRequestProcessingOut } from "../../../api/models/ServiceRequestProcessingOut";

type Props = {
  serviceRequestId: number;
};

export const RequestActivityHistory: React.FC<Props> = ({ serviceRequestId }) => {
  const { tracking, loading } = useTracking(serviceRequestId);

  if (loading) return <p>Loading activity history...</p>;
  if (!tracking.length) return <p>No activity history found.</p>;
  // console.log("Activity History:", JSON.stringify(tracking));

  return (
    <div className="activity-history-list space-y-6">
      {tracking.map((item: ServiceRequestProcessingOut) => {
        const createdTs = item.created_date
          ? new Date(item.created_date).toLocaleString()
          : "-";
        const actor = item.actor_role ?? "Unknown";
        const fromStatus = item.current_sub_status ?? "-";
        const toStatus = item.new_sub_status ?? "-";
        const statusChange = fromStatus !== toStatus;


        return (
          <div key={item.id} className="activity-entry">
            <div className="font-semibold">
              [{createdTs}] - [{actor}]: {item.title}
            </div>

            {statusChange && (
            <div className="border-tborder-gray-300 my-2">
              <div className="whitespace-pre-line  text-xs">
                Status Changes: [{fromStatus}] → {toStatus}
              </div>
              </div>
            )}
            <div className="border-tborder-gray-300 my-2"></div>
            <div className="whitespace-pre-line  text-xs">{item.notes ?? "-"}</div>
          </div>
        );
      })}
    </div>
  );
};